import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import ProfileSection from '../components/dashboard/ProfileSection';
import UploadDocuments from '../components/dashboard/UploadDocuments';
import InvoicesView from '../components/dashboard/InvoicesView';
import DashboardMenu, { Section } from '../components/dashboard/Menu';

const Dashboard: React.FC = () => {
  const [activeSection, setActiveSection] = useState<Section>('profile');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const renderContent = () => {
    switch (activeSection) {
      case 'profile':
        return <ProfileSection />;
      case 'documents':
        return <UploadDocuments />;
      case 'invoices':
        return <InvoicesView />;
      default:
        return <ProfileSection />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#144A7B] to-[#2F75B5] text-white py-6 px-4 shadow-lg">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold">Dashboard - Centro Médico</h1>
            <p className="text-blue-100 mt-1">Gestiona tu información y documentación</p>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-blue-700 transition"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Componente Menu - Ahora todo el menú está aquí */}
          <DashboardMenu
            activeSection={activeSection}
            setActiveSection={setActiveSection}
            isMobileMenuOpen={isMobileMenuOpen}
            setIsMobileMenuOpen={setIsMobileMenuOpen}
          />

          {/* Main Content */}
          <main className="flex-1">
            {renderContent()}
          </main>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
